export default __webpack_public_path__ + "static/media/preloader.32f5d9a2.svg";